const LEADING_UNREAD_COUNT_PREFIX = /^(\(\d+\)\s+)+/;

export const stripUnreadCountPrefix = (title: string) => {
  return title.replace(LEADING_UNREAD_COUNT_PREFIX, "");
};
